import { useRouter } from "src/helpers"; // import lodash from 'lodash';
// import deepdash from 'deepdash-es';

import { withCreateChapter } from "src/modules/book/operations";
import { compose } from "src/helpers";

import CreateView from "./component";

const Create = (props) => {
    const { createChapter } = props;
    const router = useRouter();
    const { book_id } = router.query;
    const {
        query: { redirect_to, order },
    } = router;

    const onFinish = async (values: any) => {
        await createChapter(values);
        // router.push(`/tab/chapter/${book_id}`);
        router.push(redirect_to);
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return (
        <CreateView
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            order={order}
        />
    );
};

export default compose(withCreateChapter)(Create);
